var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostListItemFeedbackATd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.332 2v8h2V2h-2zm4.584 0c-.691 0-1.25.56-1.25 1.25v6.357c0 .331.131.65.365.884l4.01 4.009s1.25-.298 1.25-1.469c0-.453-.959-3.031-.959-3.031h4c.69 0 1.334-.643 1.334-1.333v-.628c0-.273-.058-.544-.168-.793l-2.003-4.504A1.248 1.248 0 0011.353 2H5.916z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "6bb10badf953d7aa7c6490462d28ce9d.svg";
export { SvgPostListItemFeedbackATd as ReactComponent };